import React from "react";
import styled from "styled-components";
import { Icon, Typography, Tooltip } from "@virkesborsen/ui-component-library";

const IconBubble = ({ icon, bgColor, iconColor, rotation }) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center bg-${bgColor} rounded-pill`}
      style={{ width: "40px", height: "40px" }}
    >
      <Icon name={icon} size="large" color={iconColor} rotation={rotation} />
    </div>
  );
};

const MetricCard = ({
  label,
  value,
  icon,
  bgColor,
  iconColor,
  rotation,
  suffix,
}) => {
  let formattedValue = value;

  if (!isNaN(Number(formattedValue)) && formattedValue !== " ") {
    formattedValue = Math.round(Number(formattedValue));
  }
  
  if (formattedValue?.length > 22) {
    formattedValue = (
      <Tooltip content={formattedValue}>
        {formattedValue.slice(0, 22)}...
      </Tooltip>
    );
  }

  return (
    <Wrapper className="text-center">
      <div className="d-flex flex-column align-items-center gap-2">
        <IconBubble
          icon={icon}
          bgColor={bgColor}
          iconColor={iconColor}
          rotation={rotation}
        />
        <Typography variant="labelLargeMedium" color="pebble-500">
          {label}
        </Typography>
        <Typography variant="subheaderMediumMedium" color="charcoal-500">
          {formattedValue}
          {formattedValue !== "-" && suffix}
        </Typography>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: center;
  min-width: 88px;

  @media (min-width: 992px) {
    min-width: 112px;
  }
`;

export { MetricCard };
